import { Link } from "react-router-dom";
import {
  Box,
  Button,
  Typography,
} from "@mui/material";

import ChartIcon from "@/assets/icons/solutions/chat-bubble-left-right.svg?react";
import { FONT_SECONDARY } from "@/theme/typography";
import { ROUTES } from "@/utils/navigation";
import { contactButtonStyles } from "./styles";

interface IProps {
  closeDropDown: () => void;
}

const MenuContacts: React.FC<IProps> = ({ closeDropDown }) => {
  return (
    <Button
      variant="text"
      color="secondary"
      component={Link}
      to={ROUTES.contactUs}
      onClick={closeDropDown}
      sx={contactButtonStyles}
      startIcon={<ChartIcon />}
    >
      <Box>
        <Typography
          variant="h4"
          component="p"
          sx={{ fontSize: "20px !important" }}
          fontFamily={FONT_SECONDARY}
          mb={1}
        >
          Contact us
        </Typography>
        <Typography variant="body2" component="p" fontWeight={400}>
          Get in touch with our 24/7 live support team for free
        </Typography>
      </Box>
    </Button>
  )
}

export default MenuContacts
